module.exports = __webpack_public_path__ + "static/img/coupon_001.e0d4a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon/coupon_001.png
// module id = 9AbC
// module chunks = 1